<style scoped>
.album-container {
  padding: 10px 30px;
}

.album-preview-img,
.album-thumb-row {
  font-size: 0;
  position: relative;
}

.image-watermark {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.album-preview-container {
  padding-bottom: 10px;
}

.album-thumb-container {
  position: relative;
}

.album-thumb-row {
  overflow-x: hidden;
  overflow-y: hidden;
  white-space: nowrap;
  text-align: left;
}

.album-thumb-col {
  float: none;
  display: inline-block;
}

.album-thumb-img {
  cursor: pointer;
}

.album-thumb-active {
  border: 1px solid #000000;
}

.album-thumb-arrow {
  position: absolute;
  z-index: 88;
  top: 50%;
  transform: translate(0, -50%);
  font-size: 25px;
  opacity: 0.6;
}

.album-thumb-arrow>svg {
  cursor: pointer;
}

.album-thumb-arrow-left {
  left: -30px;
}

.album-thumb-arrow-right {
  right: -30px;
}

.album-tag.el-tag {
  position: absolute;
  left: 0;
  top: 0;
  height: 24px;
  line-height: 22px;
  color: #ffffff;
  background-color: #ff0000;
  border: none;
  border-radius: 0;
  font-size: 12px;
  padding: 0 16px;
  font-weight: 800;
}

.album-tag.tag-special {
  background-color: #007eff;
}

.album-tag.tag-normal {
  background-color: #eaca43;
}
</style>
<template>
  <div class="album-container">
    <div class="album-preview-container">
      <div class="album-preview-img" v-for="(image, index) in images" v-show="index == currentIndex">
        <el-tag v-if="$enums.productMark.label(image.tag)" :class="`album-tag tag-${image.tag}`">{{ image.tag |
          enums('productMark') }}</el-tag>
        <component :is="image.link ? 'router-link' : 'span'" :to="image.link || ''" :target="image.target || '_self'">
          <img class="image-watermark" v-if="image.watermark" :src="image.watermarkImage">
          <img class="image-fluid" :src="image.img | imgUrl" v-if="image.img" :alt="image.title" v-reload>
          <img style="width: 100%;" :src="image.img | imgUrl" v-else :alt="image.title" v-reload>
        </component>
      </div>
    </div>
    <div class="album-thumb-container">
      <div v-show="pageCount > 1" class="album-thumb-arrow album-thumb-arrow-left" @click="turnPrevPage">
        <svg-icon icon-class="arrow-left" />
      </div>
      <el-row :gutter="10" class="album-thumb-row">
        <div :style="{ transform: tansform, transition: 'all .4s ease' }">
          <el-col class="album-thumb-col" :style="{ width: colPercent + '%' }" v-for="(image, index) in images">
            <div class="album-thumb-img" :class="{ 'album-thumb-active': index == currentIndex }"
              @mouseover="pickThumb(index)">
              <img class="image-fluid" :src="image.img | imgUrl" :alt="image.title" v-reload>
            </div>
          </el-col>
        </div>
      </el-row>
      <div v-show="pageCount > 1" class="album-thumb-arrow album-thumb-arrow-right" @click="turnNextPage">
        <svg-icon icon-class="arrow-right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 4
    },
    images: {
      type: Array,
      default() {
        return [
        ]
      }
    }
  },
  data: function () {
    return {
      currentPage: 1,
      currentIndex: 0
    }
  },
  watch: {
    value(value) {
      this.pickThumb(value)
    },
    currentPage(pageNew, pageOld) {
      if (pageNew != pageOld) {
        const direction = pageNew > pageOld ? 'right' : 'left'
        const index = (direction === 'right') ? (pageNew - 1) * this.pageSize : (pageNew * this.pageSize - 1)
        this.pickThumb(index)
      }
    }
  },
  computed: {
    pageCount: function () {
      return Math.ceil(this.images.length / this.pageSize)
    },
    colPercent: function () {
      return 100 / this.pageSize
    },
    tansform: function () {
      const percent = (100 * (this.currentPage - 1))
      return `translate(-${percent}%, 0)`
    },
    isFirstPage: function () {
      return this.currentPage === 1
    },
    isLastPage: function () {
      return this.currentPage === this.pageCount
    }
  },
  methods: {
    pickThumb(index) {
      this.currentIndex = index
      this.currentPage = Math.ceil((index + 1) / this.pageSize)
      this.$emit('input', index)
    },
    turnNextPage() {
      if (!this.isLastPage) {
        this.currentPage++;
      }
    },
    turnPrevPage() {
      if (!this.isFirstPage) {
        this.currentPage--;
      }
    }
  },
  mounted: function () {
    this.pickThumb(this.value)
  }
}
</script>
